module.exports = __webpack_public_path__ + "static/media/2d-controls-selected-icon.1f281e65.svg";